import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from 'src/config/config';
import { apiConstants } from "../constant/apiConstant";
import { map, retry } from 'rxjs';
import { commonFunctionService } from '../utils/commonFunctions';

@Injectable({
    providedIn: 'root'
})
export class AcademicHolidaysService {

    schoolData = localStorage.getItem('schoolAllInfo');
    parsedData = JSON.parse(this.schoolData);
    academicId = this.parsedData?.currentAcademicId;
    private URL_V3 = AppSettings.API_ENDPOINT_V3;
    private language = "en";
    private params = new HttpParams().set("lang", this.language).set("academicId", this.academicId);

    constructor(private http: HttpClient, private commonFunctionService: commonFunctionService) { }

    getClassListService() {
        return this.http
            .get(this.URL_V3 + apiConstants.getCompleteClassListApiEndpoint, {
                headers: this.commonFunctionService.appendHeader(),
                params: this.params,
            })
            .pipe(map((res) => res));
    }

    getHolidayListService() {
        return this.http
            .get(this.URL_V3 + apiConstants.getHolidaysListApiEndpoint, {
                headers: this.commonFunctionService.appendHeader(),
                params: this.params
            })
            .pipe(map((res) => res));
    }

    createHolidayService(body: any) {
        const headers = this.commonFunctionService.appendHeader();
        const url = this.URL_V3 + apiConstants.createHoildayApiEndpoint;
        return this.http.post(url, body, { headers }).pipe(map((res) => res));
    }

    deleteHolidayService(body: any) {
        const headers = this.commonFunctionService.appendHeader();
        const url = this.URL_V3 + apiConstants.deleteHoildayApiEndpoint;
        return this.http.delete(url, { body, headers }).pipe(map((res) => res));
    }

    editHolidayService(body: any) {
        const headers = this.commonFunctionService.appendHeader();
        const url = this.URL_V3 + apiConstants.editHoildayApiEndpoint;
        return this.http.put(url, body, { headers }).pipe(map((res) => res));
    }
}
